module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_up_error.85fd794d.svg";